
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"63","height":"63","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 31.5C0 14.103 14.103 0 31.5 0S63 14.103 63 31.5 48.897 63 31.5 63 0 48.897 0 31.5z","fill":"#1BBAC8"}}),_c('path',{attrs:{"d":"M45.25 16.938A3.942 3.942 0 0041.312 13H22.939A3.942 3.942 0 0019 16.938v28.875a3.942 3.942 0 003.938 3.937h18.375a3.942 3.942 0 003.937-3.938V16.939zM24.906 45.813a1.969 1.969 0 110-3.938 1.969 1.969 0 010 3.938zm0-6.563a1.969 1.969 0 110-3.938 1.969 1.969 0 010 3.938zm0-6.563a1.969 1.969 0 110-3.937 1.969 1.969 0 010 3.938zm7.219 13.126a1.97 1.97 0 110-3.939 1.97 1.97 0 010 3.938zm0-6.563a1.97 1.97 0 110-3.938 1.97 1.97 0 010 3.938zm0-6.563a1.97 1.97 0 110-3.938 1.97 1.97 0 010 3.939zm9.188 11.157a1.969 1.969 0 11-3.938 0V37.28a1.969 1.969 0 113.938 0v6.563zm-1.97-11.157a1.969 1.969 0 110-3.937 1.969 1.969 0 010 3.938zm1.585-8.26c-.246.247-.58.385-.928.386H24.25a1.313 1.313 0 01-1.313-1.313v-5.25a1.313 1.313 0 011.313-1.313H40a1.313 1.313 0 011.313 1.313v5.25c0 .348-.139.682-.385.928z","fill":"#fff"}})])
          )
        }
      }
    